import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetRoomTypes } from "../../../store/roomtype-store/roomtype-actions";
import ABADatatable from "../../../components/ABADatatable";
import { roomtypeActions } from "../../../store/roomtype-store/roomtype-slice";
import { Button } from "primereact/button";

const RoomTypeHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const roomtypes = useSelector((state) => state.roomtype.roomtypes);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth.roles !== undefined && auth.roles.includes("roomtype.showAll")) {
      dispatch(GetRoomTypes(auth.UserInfo.email, true, true));
    }
  }, [dispatch, auth]);

  const viewDetailHanlder = (val) => {
    navigate(`/roomtype/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/roomtype/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      roomtypeActions.setRoomType({
        roomtype: {
          id: 0,
          name: "",
          description: "",
          status: false,
          quantity: 0,
        },
      })
    );
    navigate(`/roomtype/create`);
  };
  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (auth.roles !== undefined && auth.roles.includes("roomtype.edit")) {
      buttons.push(buttonEdit);
    }
    if (auth.roles !== undefined && auth.roles.includes("roomtype.view")) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },
    {
      field: "quantity",
      header: "Cantidad",
      filterMatchMode: "contains",
    },

    {
      field: "description",
      header: "Descripción",
      filterMatchMode: "contains",
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];
  return (
    <>
      <ABADatatable
        width="20%"
        title="Tipos de Habitación"
        values={roomtypes}
        rows={5}
        rowsPerPageOptions={[5, 10, 20]}
        Columns={columns}
        actions={actions}
        createButton={{
          label: "Crear tipo de habitación",
          onClick: createHanlder,
          permission: "roomtype.create",
        }}
        backButton={{
          label: "Regresar",
          onClick: backHanlder,
          permission: "goBack",
        }}
      />
    </>
  );
};
export default RoomTypeHomePage;
